<script>
import moment from "moment";
import axios from '@/utils/axios';
import "daterangepicker/daterangepicker.js";
import "daterangepicker/daterangepicker.css";
import DateRangePicker from "daterangepicker";
import Vue3ChartJs from "@j-t-mcc/vue3-chartjs";
import StatusBadge from '@/components/common/sampling-status-badge.vue';

export default {
  inject: ['setLoading'],
  components: {
    Vue3ChartJs,
    StatusBadge
  },
  data() {
    return {
      errors: {},
      title: "Reports",
      text: "Sampling Detailed Report",
      text1: "Reports",
      isCollapsed: false,
      app_currency: '',
      filter: {
       user: '',
       status: '',
       to_date: '',
       from_date: '',
      },
      users: [],
      data: [],
      pagination: {
       current_page: 1,
       per_page: 25,
       last_page: 1,
       total: 0,
       links: []
      },
    };
  },

  computed: {
   serialNo() {
    return (this.pagination.current_page - 1) * this.pagination.per_page;
   }
  },

  async mounted() {
   this.getUsers();
   this.app_currency = await this.$appCurrency();

   const start = moment().subtract(1, "month");
   const end = moment();

   new DateRangePicker(
    this.$refs.dateRangeInput,
    {
     startDate: start,
     endDate: end,
      locale: {
        format: "DD/MM/YYYY",
        separator: " - "
      },
      ranges: {
        Today: [moment(), moment()],
        Yesterday: [moment().subtract(1, "days"), moment().subtract(1, "days")],
        "Last 7 Days": [moment().subtract(6, "days"), moment()],
        "Last 30 Days": [moment().subtract(29, "days"), moment()],
        "This Month": [moment().startOf("month"), moment().endOf("month")],
        "Last Month": [
          moment().subtract(1, "month").startOf("month"),
          moment().subtract(1, "month").endOf("month"),
        ],
      }
     },
     (start, end) => {
      this.setDateRange(start, end);
     },
     this.booking_range
    );
    
    // Initialize filter date range as soon as picker mounts
    this.setDateRange(start, end);

    //LOAD DATA
    this.filterReport();
  },

  methods: {
   booking_range(start, end) {
    return start.format("DD/MM/YYYY") + " - " + end.format("DD/MM/YYYY");
   },

   setDateRange(start, end) {
    this.filter.from_date = start.format("YYYY-MM-DD");
    this.filter.to_date = end.format("YYYY-MM-DD");
   },

   async filterReport(page = 1) {
    this.errors = {};
    this.setLoading(true);
    try {
      const payload = {
        page,
        user_id: this.filter.user,
        status: this.filter.status,
        to_date: this.filter.to_date,
        from_date: this.filter.from_date,
      };
      const query_string = new URLSearchParams(payload).toString(); 
      const response = await axios.get(`/reports/sampling/detailed?${query_string}`);
      this.data = response.data.data.samplings.data;
        
      this.pagination = {
       current_page: response.data.data.samplings.current_page,
       per_page: response.data.data.samplings.per_page,
       last_page: response.data.data.samplings.last_page,
       total: response.data.data.samplings.total,
       links: response.data.data.samplings.links
      };

     }catch(error){
      if(error.type == 'validation'){
       this.errors = error.errors;
      }else{
       this.$swalToast(error.message, 'error');
      }
     }finally{
      this.setLoading(false);
     }
    },

    async getUsers() {
     this.setLoading(true);
     try{
      const response = await axios.get('/users/all-users');
      this.users = response.data.data;
     }catch(error){
      this.$swalToast(error.message, 'error');
     }finally{
      this.setLoading(false);
     }
    },

    async quickExport(format) {
     const payload = {
      user_id: this.filter.user,
      status: this.filter.status,
      from_date: this.filter.from_date,
      to_date: this.filter.to_date,
     };
     await this.downloadExport(`/exports/sampling-requests/${format}`, payload);
    },

    async downloadExport(url, payload) {
     this.setLoading(true);
     try {
      const response = await axios.post(url, payload, {
       responseType: 'blob',
      });

      const blob = new Blob([response.data], {
       type: response.headers['content-type'],
      });

      const link = document.createElement('a');
      link.href = URL.createObjectURL(blob);

      const format = url.split('/').pop(); // Extract format from URL
      let filename = `sampling_report_${this.$timeStamp()}.${format}`;
      const disposition = response.headers['content-disposition'];

      if(disposition && disposition.indexOf('filename=') !== -1){
       const filenameMatch = disposition.match(/filename="?(.+)"?/);
       if(filenameMatch && filenameMatch.length === 2){
        filename = filenameMatch[1];
       }
      }

      link.download = filename;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      URL.revokeObjectURL(link.href);

      this.$swalToast('Export downloading...', 'success');
     }catch(error){
      console.error(error);
      this.$swalToast(error?.response?.data?.message || 'Export failed', 'error');
     }finally{
      this.setLoading(false);
     }
    },

    changePage(url) {
     if (!url) return;
     const page = new URL(url).searchParams.get("page");
     this.filterReport(page);
    },

    clearFilter() {
     this.filter = {
      user: '',
      status: '',
      to_date: '',
      from_date: '', 
     };
     // Reload with default date range (last month)
     const start = moment().subtract(1, "month");
     const end = moment();
     this.setDateRange(start, end);
     this.filterReport();
    }

  }
};
</script>

<template>
<layout-header></layout-header>
<layout-sidebar></layout-sidebar>
<div class="page-wrapper">
<div class="content">
<!-- Breadcrumb -->
<div class="d-md-flex d-block align-items-center justify-content-between page-breadcrumb mb-3">
<breadcrumb :title="title" :text="text" :text1="text1" />
<div class="d-flex my-xl-auto right-content align-items-center flex-wrap">
    <!-- Enhanced Export Dropdown -->
<div class="me-2 mb-2" v-if="data?.length">
<div class="dropdown">
 <a href="javascript:void(0);" class="dropdown-toggle btn btn-white d-inline-flex align-items-center" data-bs-toggle="dropdown"><i class="ti ti-file-export me-1"></i>Export</a>
 <ul class="dropdown-menu dropdown-menu-end p-3">
 <!-- Quick Export -->
 <li>
  <a href="javascript:void(0);" class="dropdown-item rounded-1" @click="quickExport('csv')">
   <i class="ti ti-file-type-csv me-1"></i>Export as CSV
  </a>
 </li>
 <li>
  <a href="javascript:void(0);" class="dropdown-item rounded-1" @click="quickExport('xlsx')">
   <i class="ti ti-file-type-xls me-1"></i>Export as Excel
  </a>
 </li>

</ul>
</div>
</div>
</div>
</div>
<!-- /Breadcrumb -->

<div class="card border-0">
<div class="card-body d-flex align-items-center justify-content-center flex-wrap pb-1">
 <div class="d-flex align-items-center flex-wrap mb-1">
 <div class="me-3" v-if="filter.user || filter.status">
  <a href="javascript:void(0);" class="text-danger" @click="clearFilter()">
  <i class="ti ti-filter-x"></i>
  </a>
 </div> 

 <div class="me-3">
  <div class="input-icon-end position-relative">
   <input type="text" class="form-control date-range bookingrange" ref="dateRangeInput" placeholder="dd/mm/yyyy - dd/mm/yyyy">
   <span class="input-icon-addon"><i class="ti ti-chevron-down"></i></span>
  </div>
 </div>

 <div class="me-3">
  <div class="input-icon-end position-relative">
    <select class="form-control" v-model="filter.status" @change="filterReport();">
    <option value="">Status</option>
    <option value="pending">Pending</option>
    <option value="overdue">Overdue</option>
    <option value="dispatched">Dispatched</option>
    <option value="delivered">Delivered</option>
    </select>
  </div>
 </div>

 <div class="me-3">
  <select class="form-select" v-model="filter.user" @change="filterReport()">
   <option value="">Created By</option>
   <option :value="row.id" v-for="row in users" :key="row.id">{{row.name}}</option>
  </select>
  <div class="text-danger small mt-1" v-if="errors.user_id">{{ errors.user_id[0] }}</div>
 </div>

 <div class="me-3">
  <button type="button" class="btn btn-dark" @click="filterReport">
   <i class="ti ti-search"></i>
  </button>
 </div>
</div>
</div>
</div>

<div class="row">
<div class="col-lg-12">
<div class="custom-datatable-filter table-responsive">
 <table class="table datatable thead-light" v-if="data?.length">
    <thead>
    <tr>
        <th>#</th>
        <th>Request No</th>
        <th>Status</th>
        <th>Created By</th>
        <th>Client Name</th>
        <th>Client Company</th>
        <th>Created On</th>
    </tr>
    </thead>
    <tbody>
    <tr v-for="(row, index) in data" :key="row.id" :class="{ 'table-danger fw-bold': row.is_overdue }">
        <td>{{ serialNo + index + 1 }}.</td>
        <td>
        <h6 class="fs-14 fw-medium"> 
         <a data-bs-toggle="modal" data-bs-target="#sampling_detail_modal" @click="$refs.samplingModal.sampling(row)">{{ row.request_number }}</a> 
        </h6>
        </td>
        <td><StatusBadge :status="row.status"></StatusBadge></td>
        <td>{{ row.created_by?.name }}</td>
        <td>
        <h6 class="fs-14 fw-medium"> 
         <a :href="$partyURL(row.party_id, row.party_type)" target="_blank">{{ row.party?.name }}</a>
        </h6>
        </td>
        <td>
        <h6 class="fs-14 fw-medium"> 
            <a :href="$partyURL(row.party_id, row.party_type)" target="_blank">{{ row.party?.company_name }}</a> 
        </h6>
        </td>
        <td>{{ $formatDate(row.created_at) }}</td>
    </tr>
    </tbody>
    </table>

    <div v-else class="p-3 text-center text-muted"> No records found.</div>

    <!-- Pagination -->
    <nav v-if="pagination.links && pagination.links.length > 3" class="m-3">
        <ul class="pagination pagination-sm">
        <li v-for="(link, index) in pagination.links" :key="index"
            :class="['page-item', { active: link.active, disabled: !link.url }]">
            <a class="page-link" href="javascript:void(0)" v-html="link.label" @click="changePage(link.url)"></a>
        </li>
        </ul>
    </nav>
    </div>
</div>  
</div>
</div>

<app-footer></app-footer>
</div>

<sampling-modal ref="samplingModal"></sampling-modal>
</template>
<style scoped>
.table-responsive {
  overflow-y: auto;
}
</style>